
// import React from 'react';
// import { Button, Tooltip, Grid } from '@mui/material';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';
// import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
// import {
//   Add as AddIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   CancelPresentation as CancelPresentationIcon,
//   LocalPrintshop as PrintIcon
// } from '@mui/icons-material';

// const CrudButtons = ({ permissions, mode, onAdd, onEdit, onView, onDelete, onExit, readOnlyMode, onPrevious, onNext }) => {
//   // Extract permissions with defaults
//   const {
//     AddRec = "0",
//     EditRec = "0",
//     DeleteRec = "0",
//     ViewRec = "0"
//   } = permissions || {};

//   // Common button styles
//   const buttonSx = {
//     backgroundColor: "#635bff",
//     // margin: "0px 6px",
//     backgroundColor: '#635bff', margin: { xs: '0px 5px', sm: '0px 5px' }, minWidth: { xs: '40px', sm: '40px', md: '60px' },
//     "&:disabled": {
//       backgroundColor: "rgba(0, 0, 0, 0.12)",
//       color: "rgba(0, 0, 0, 0.26)",
//       boxShadow: "none",
//     }
//   };

//   const getTooltipMessage = (permission) => {
//     return permission === "0" ? "You don't have permission for this action" : "";
//   };

//   return (
//     <>
//       <Grid
//         sx={{
//           display: 'flex',
//           justifyContent: { xs: 'center', sm: 'center' },
//           margin: { xs: '10px 0px 0px 0px', sm: 0 }
//         }}
//       >
//         <Button
//           variant="contained"
//           size="small"
//           onClick={onPrevious}
//           sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'block', sm: 'none' } }}
//           className="three-d-button-previous"
//         >
//           <KeyboardArrowLeftIcon />
//         </Button>
//         <Button
//           variant="contained"
//           size="small"
//           onClick={onNext}
//           sx={{ backgroundColor: '#635BFF', display: { xs: 'block', sm: 'none' } }}
//           className="three-d-button-next"
//         >
//           <NavigateNextIcon />
//         </Button>
//         <Tooltip title={getTooltipMessage(AddRec)}>
//           <span>
//             <Button
//               variant="contained"
//               size="small"
//               sx={buttonSx}
//               onClick={onAdd}
//               disabled={!readOnlyMode || AddRec === "0"}
//             >
//               <AddIcon />
//             </Button>
//           </span>
//         </Tooltip>

//         <Tooltip title={getTooltipMessage(EditRec)}>
//           <span>
//             <Button
//               variant="contained"
//               size="small"
//               sx={buttonSx}
//               onClick={onEdit}
//               disabled={!readOnlyMode || EditRec === "0"}
//             >
//               <EditIcon />
//             </Button>
//           </span>
//         </Tooltip>

//         <Tooltip title={getTooltipMessage(DeleteRec)}>
//           <span>
//             <Button
//               variant="contained"
//               size="small"
//               sx={buttonSx}
//               onClick={onDelete}
//               disabled={!readOnlyMode || DeleteRec === "0"}
//             >
//               <DeleteIcon />
//             </Button>
//           </span>
//         </Tooltip>

//         <Tooltip title={getTooltipMessage(ViewRec)}>
//           <span>
//             <Button
//               variant="contained"
//               size="small"
//               sx={buttonSx}
//               onClick={onView}
//               disabled={!readOnlyMode || ViewRec === "0"}
//             >
//               <PrintIcon />
//             </Button>
//           </span>
//         </Tooltip>
//         <Button
//           variant="contained"
//           size="small"
//           sx={buttonSx}
//           onClick={onExit}
//           disabled={!readOnlyMode}
//         >
//           <CancelPresentationIcon />
//         </Button>
//       </Grid>
//     </>
//   );
// };

// export default CrudButtons;



import React from 'react';
import { Button, Tooltip, Grid } from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CancelPresentation as CancelPresentationIcon,
  LocalPrintshop as PrintIcon
} from '@mui/icons-material';
import { usePermissions } from '../GlobalFunction/userPermissions';


const CrudButtons = ({ moduleName, mode, onAdd, onEdit, onView, onDelete, onExit, readOnlyMode,
  hideAdd = false,
  hideEdit = false,
  hideDelete = false,
  hideView = false,
  hideExit = false,
  forceDisableDelete = false

}) => {
  const permissions = usePermissions(moduleName);

  const buttonSx = {
    backgroundColor: '#635bff',
    "&:hover": { backgroundColor: '#635bff' },
    margin: { xs: '0px 5px', sm: '0px 5px' },
    minWidth: { xs: '40px', sm: '40px', md: '60px' },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)",
      boxShadow: "none",
    }
  };

  // const getTooltipMessage = (permission) => {
  //   return permission === "0" ? "You don't have permission for this action" : "";
  // };
  const getTooltipMessage = (action, permission) => {
    const actionMessages = {
      add: "Add",
      edit: "Edit",
      delete: "Delete ",
      view: "Print ",
      exit: "Exit"
    };

    if (permission === "0") {
      return "You don't have permission for this action";
    }

    return actionMessages[action] || "";
  };

  return (
    <Grid
      sx={{
        display: 'flex',
        justifyContent: { xs: 'center', sm: 'center' },
        margin: { xs: '10px 0px 0px 0px', sm: 0 }
      }}
    >
      {!hideAdd && (
        <Tooltip title={getTooltipMessage("add", permissions.AddRec)} arrow>
          <span>
            <Button
              variant="contained"
              size="small"
              sx={buttonSx}
              onClick={onAdd}
              disabled={!readOnlyMode || permissions.AddRec === "0"}
            >
              <AddIcon />
            </Button>
          </span>
        </Tooltip>
      )}
      {/* <Tooltip title={getTooltipMessage(permissions.EditRec)}> */}
      {!hideEdit && (
        <Tooltip title={getTooltipMessage("edit", permissions.EditRec)} arrow>
          <span>
            <Button
              variant="contained"
              size="small"
              sx={buttonSx}
              onClick={onEdit}
              disabled={!readOnlyMode || permissions.EditRec === "0"}
            >
              <EditIcon />
            </Button>
          </span>
        </Tooltip>
      )}
      {/* <Tooltip title={getTooltipMessage(permissions.DeleteRec)}> */}
      {!hideDelete && (
        // <Tooltip title={getTooltipMessage("delete", permissions.DeleteRec)} arrow>
        <Tooltip title={forceDisableDelete ? "Delete is disabled for this module" : getTooltipMessage("delete", permissions.DeleteRec)} arrow>
          <span>
            <Button
              variant="contained"
              size="small"
              sx={{
                ...buttonSx,
                ...(forceDisableDelete && { opacity: 0.5, cursor: 'not-allowed' })
              }}
              onClick={onDelete}
              // disabled={!readOnlyMode || permissions.DeleteRec === "0"}
              disabled={forceDisableDelete || !readOnlyMode || permissions.DeleteRec === "0"}
            >
              <DeleteIcon />
            </Button>
          </span>
        </Tooltip>
      )}
      {/* <Tooltip title={getTooltipMessage(permissions.ViewRec)}> */}
      <Tooltip title={getTooltipMessage("view", permissions.ViewRec)} arrow>
        <span>
          <Button
            variant="contained"
            size="small"
            sx={buttonSx}
            onClick={onView}
            disabled={!readOnlyMode || permissions.ViewRec === "0"}
          >
            <PrintIcon />
          </Button>
        </span>
      </Tooltip>
      <Tooltip title={getTooltipMessage("exit")} arrow>
        <Button
          variant="contained"
          size="small"
          sx={buttonSx}
          onClick={onExit}
          disabled={!readOnlyMode}
        >

          <CancelPresentationIcon />
        </Button>
      </Tooltip>
    </Grid>
    // =======
    //         <Button
    //           variant="contained"
    //           size="small"
    //           onClick={onPrevious}
    //           sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'block', sm: 'none' } }}
    //           className="three-d-button-previous"
    //         >
    //           <KeyboardArrowLeftIcon />
    //         </Button>
    //         <Button
    //           variant="contained"
    //           size="small"
    //           onClick={onNext}
    //           sx={{ backgroundColor: '#635BFF', display: { xs: 'block', sm: 'none' } }}
    //           className="three-d-button-next"
    //         >
    //           <NavigateNextIcon />
    //         </Button>
    //         <Tooltip title={getTooltipMessage(AddRec)}>
    //           <span>
    //             <Button
    //               variant="contained"
    //               size="small"
    //               sx={buttonSx}
    //               onClick={onAdd}
    //               disabled={!readOnlyMode || AddRec === "0"}
    //             >
    //               <AddIcon />
    //             </Button>
    //           </span>
    //         </Tooltip>

    //         <Tooltip title={getTooltipMessage(EditRec)}>
    //           <span>
    //             <Button
    //               variant="contained"
    //               size="small"
    //               sx={buttonSx}
    //               onClick={onEdit}
    //               disabled={!readOnlyMode || EditRec === "0"}
    //             >
    //               <EditIcon />
    //             </Button>
    //           </span>
    //         </Tooltip>

    //         <Tooltip title={getTooltipMessage(DeleteRec)}>
    //           <span>
    //             <Button
    //               variant="contained"
    //               size="small"
    //               sx={buttonSx}
    //               onClick={onDelete}
    //               disabled={!readOnlyMode || DeleteRec === "0"}
    //             >
    //               <DeleteIcon />
    //             </Button>
    //           </span>
    //         </Tooltip>

    //         <Tooltip title={getTooltipMessage(ViewRec)}>
    //           <span>
    //             <Button
    //               variant="contained"
    //               size="small"
    //               sx={buttonSx}
    //               onClick={onView}
    //               disabled={!readOnlyMode || ViewRec === "0"}
    //             >
    //               <PrintIcon />
    //             </Button>
    //           </span>
    //         </Tooltip>
    //         <Button
    //           variant="contained"
    //           size="small"
    //           sx={buttonSx}
    //           onClick={onExit}
    //           // disabled={!readOnlyMode}
    //         >
    //           <CancelPresentationIcon />
    //         </Button>
    //       </Grid>
    //     </>
    // >>>>>>> main
  );
};

export default CrudButtons;